interface RHBase64Download {
    base64: string
    mimeType: string
    fileName: string
}

export class ProcurementExcelExportDownloader {

    static download(exportData: RHBase64Download) {
        const byteCharacters = atob(exportData.base64)
        const byteNumbers: number[] = []

        for (let index = 0; index < byteCharacters.length; index++) {
            byteNumbers.push(byteCharacters.charCodeAt(index))
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: exportData.mimeType })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement("a")
        anchor.href = url
        anchor.download = exportData.fileName
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
        window.URL.revokeObjectURL(url)
    }

}
